import React from 'react';
import { SvgLogoIcon } from './LogoIcon';
import styled from 'styled-components';
import { Tooltip } from '../Tooltip';
const StyledLogo = styled.a `
  display: flex;
  color: var(--color-base-white) !important;
  align-items: center;
  transition: none;
  &:hover {
    text-decoration: none;
  }

  h3 {
    color: var(--color-base-white);
    font-size: 19px;
    font-weight: 500;
    white-space: nowrap;
  }

  &:hover svg,
  &:active svg {
    color: var(--color-base-white);
  }

  sup {
    color: var(--color-base-gray3);
    margin-left: 4px;
    top: -0.2em;
    white-space: nowrap;
  }
`;
const StyledLogoIcon = styled.div `
  display: flex;
  margin-right: 5px;

  svg {
    width: 16px;
    height: 24px;
    position: relative;
    top: 1px;
  }
`;
export function Logo({ title, url, version, fullVersion }) {
    return (React.createElement(StyledLogo, { href: url, as: url ? 'a' : 'div' },
        React.createElement(StyledLogoIcon, null,
            React.createElement(SvgLogoIcon, null)),
        React.createElement("h3", null, title),
        version && (React.createElement(Tooltip, { title: fullVersion || version },
            React.createElement("sup", null, version)))));
}
